import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["remaining", "button"];
  static values = { until: String };

  connect() {
    this.until = new Date(this.untilValue).getTime();
    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnect() {
    clearInterval(this.timer);
  }

  tick() {
    const seconds = Math.max(0, Math.ceil((this.until - Date.now()) / 1000));

    if (seconds === 0) {
      clearInterval(this.timer);
      this.remainingTarget.textContent = "Nu kan svaret sendes";
      this.buttonTarget.classList.replace("btn-outline-secondary", "btn-primary");
      return;
    }

    const minutes = Math.floor(seconds / 60);
    this.remainingTarget.textContent = `${minutes}:${String(seconds % 60).padStart(2, "0")} tilbage`;
  }
}
